export const AUTH_SWITCH = true // 權限開关
export const SPECIAL_AUTH_ID = [// 非常规处理的權限资源ID集合
]
